var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNok = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.414062 15.3962C1.10838 17.9724 2.63861 20.2053 4.69633 21.7863V15.3962H0.414062Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.957 24.2201C11.301 24.2498 11.6489 24.2658 12.0005 24.2658C17.5448 24.2658 22.2101 20.5054 23.5871 15.3962H10.957V24.2201Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5871 9.13688C22.2101 4.02769 17.5448 0.267334 12.0005 0.267334C11.6489 0.267334 11.301 0.283365 10.957 0.31299V9.13688H23.5871Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69633 2.7478C2.63861 4.3289 1.10838 6.56169 0.414062 9.1379H4.69633V2.7478Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.7021H9.39136H9.39131V0.55249C8.28234 0.798396 7.23098 1.19697 6.26086 1.72633V10.702V10.702H0.101578C0.0347813 11.2144 0 11.7368 0 12.2673C0 12.7977 0.0347813 13.3201 0.101578 13.8325H6.26081H6.26086V22.8081C7.23098 23.3374 8.28234 23.7361 9.39131 23.982V13.8326V13.8325H23.8984C23.9651 13.3201 24 12.7977 24 12.2673C24 11.7368 23.9651 11.2144 23.8984 10.7021Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NOK.d4f2c74032b0ae3ce64b4fc690f4227f.svg";